const rawBase = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
const rawGoogleMapsApiKey = (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined)?.trim();
const rawPatientPortalUrl = (import.meta.env.VITE_PATIENT_PORTAL_URL as string | undefined)?.trim();
const rawPatientPortalEnabled = (import.meta.env.VITE_PATIENT_PORTAL_ENABLED as string | undefined)?.trim().toLowerCase();

const browserHostname = typeof window === 'undefined' ? '' : window.location.hostname.trim().toLowerCase();
const isHostedRuntime = browserHostname !== '' && browserHostname !== 'localhost' && browserHostname !== '127.0.0.1';
const hostedApiBase = 'https://api.elen1.com';
const hostedPatientPortalUrl = 'https://patient.elen1.com';

function isLocalHttpUrl(value?: string | null) {
  return typeof value === 'string' && /^https?:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?(?:\/|$)/i.test(value.trim());
}

function resolveRuntimeUrl(rawValue: string | undefined, localFallback: string, hostedFallback: string) {
  if (rawValue && rawValue.startsWith('http') && !(isHostedRuntime && isLocalHttpUrl(rawValue))) {
    return rawValue;
  }
  return isHostedRuntime ? hostedFallback : localFallback;
}

export const API_BASE = resolveRuntimeUrl(rawBase, 'http://localhost:4040', hostedApiBase);
export const AUTH_AUDIENCE = (import.meta.env.VITE_AUTH0_AUDIENCE as string | undefined) || '';
export const GOOGLE_MAPS_API_KEY = rawGoogleMapsApiKey || 'AIzaSyCXOub044DU4X_SSX7AJsxWG-IGmPKNJcAm n ';
export const PATIENT_PORTAL_URL = resolveRuntimeUrl(rawPatientPortalUrl, '', hostedPatientPortalUrl);
export const PATIENT_PORTAL_ENABLED =
  rawPatientPortalEnabled === undefined ||
  rawPatientPortalEnabled === '' ||
  rawPatientPortalEnabled === '1' ||
  rawPatientPortalEnabled === 'true' ||
  rawPatientPortalEnabled === 'yes' ||
  rawPatientPortalEnabled === 'on';
